/**
 * API-Client für /api/shift-swaps (Phase E, Kapitel 6 — Schichttausch).
 */

import { apiFetch } from './api';
import type { ApiShift } from './shifts';

export type ShiftSwapStatus = 'pending' | 'accepted' | 'rejected' | 'cancelled';

export interface ApiShiftSwap {
  id: string;
  shiftId: string;
  fromUserId: string;
  toUserId: string | null;
  status: ShiftSwapStatus;
  note: string | null;
  createdAt: string;
  resolvedAt: string | null;
  /** Screen 10: Schicht liegt an einem Standort, an dem ich nicht zugeordnet bin (nur in GET-Listen). */
  crossLocation?: boolean;
  /** Screen 10: Standort erlaubt Tausch über Standortgrenzen (nur in GET-Listen). */
  openToOtherLocations?: boolean;
  shift: {
    id: string;
    locationId: string;
    locationName: string;
    shiftDate: string;
    startTime: string;
    endTime: string;
  };
}

export interface CreateSwapInput {
  shiftId: string;
  toUserId?: string | null;
  note?: string | null;
}

export interface EligibleColleague {
  id: string;
  name: string;
}

export const shiftSwapsApi = {
  list: (token: string) =>
    apiFetch<{ swaps: ApiShiftSwap[] }>('/api/shift-swaps', { token }).then((r) => r.swaps),

  create: (token: string, data: CreateSwapInput) =>
    apiFetch<{ swap: ApiShiftSwap }>('/api/shift-swaps', { method: 'POST', body: data, token }).then(
      (r) => r.swap,
    ),

  accept: (token: string, id: string) =>
    apiFetch<{ swap: ApiShiftSwap; shift: ApiShift }>(`/api/shift-swaps/${id}/accept`, {
      method: 'POST',
      token,
    }),

  reject: (token: string, id: string) =>
    apiFetch<{ swap: ApiShiftSwap }>(`/api/shift-swaps/${id}/reject`, { method: 'POST', token }),

  cancel: (token: string, id: string) =>
    apiFetch<{ swap: ApiShiftSwap }>(`/api/shift-swaps/${id}/cancel`, { method: 'POST', token }),

  eligibleColleagues: (token: string, shiftId: string) =>
    apiFetch<{ colleagues: EligibleColleague[] }>(
      `/api/shift-swaps/eligible-colleagues/${shiftId}`,
      { token },
    ).then((r) => r.colleagues),
};
